import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LoadingComponent } from 'recupero-comunes';
import Formulario from './formulario';
import { getAntecedentesCaso } from '../../../api/api-consultar-caso';
import { serviceGetAsistenciasPreliminares } from '../../../api/api-asigna-abogado';

// RG-565 — "Iniciar Gestión Defensa Penal - Asignación de Abogado" (tarea WFL 15).
const AsignarAbogado = ({ showModal, setShowModal, row, onTareaGestionada }) => {

    const [loading, setLoading] = useState(false);
    const [antecedentes, setAntecedentes] = useState(null);
    const [asistencias, setAsistencias] = useState([]);

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    useEffect(() => {
        if (showModal && llaves?.idCaso) cargarDatos();
    }, [showModal]);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            const qCaso = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idOrgCaso: llaves.idOrgCaso })).toString('base64');
            const dataCaso = await getAntecedentesCaso(qCaso);
            const caso = dataCaso && dataCaso.length > 0 ? dataCaso[0] : null;
            setAntecedentes(caso);

            if (caso?.FechaSiniestroFmt) {
                const qAsist = Buffer.from(JSON.stringify({ fechaSiniestro: caso.FechaSiniestroFmt })).toString('base64');
                const dataAsist = await serviceGetAsistenciasPreliminares(qAsist);
                setAsistencias(dataAsist || []);
            } else {
                setAsistencias([]);
            }
        } catch (error) {
            console.log('Error al cargar datos Asignar Abogado:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => setShowModal(false);

    return (
        <Fragment>
            <Modal show={showModal} onHide={handleClose} size='xl' backdrop='static'>
                <LoadingComponent show={loading} />
                <Formulario
                    showModal={showModal}
                    setShowModal={setShowModal}
                    row={row}
                    llaves={llaves}
                    antecedentes={antecedentes}
                    asistencias={asistencias}
                    setAsistencias={setAsistencias}
                    recargarDatos={cargarDatos}
                    onTareaGestionada={onTareaGestionada}
                />
            </Modal>
        </Fragment>
    );
};

export default AsignarAbogado;
